import { AUTH_TYPES, AuthAccountAction } from './auth.types';

export const authAccount = (): AuthAccountAction => ({
  type: AUTH_TYPES.AUTHENTICATE_ACCOUNT,
});
